// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__9fFeH","cell":"styles_cell__zyn5x","cell__full":"styles_cell__full__OdAcU"};